import { FC } from 'react';
import { useSingleCourse, type CourseStep } from '../../../contexts/SingleCourseProvider';
import { SingleStep } from './SingleStep';
import { StepProgressBar } from './StepProgressBar';
import { COURSE_STEPS } from './courseStepsConfig';

export const StepsHeader: FC = () => {
  const { course, activeStep, setActiveStep } = useSingleCourse();

  const handleStepClick = (step: CourseStep) => {
    setActiveStep(step);
  };

  return (
    <div className="relative flex justify-around items-start">
      <StepProgressBar />

      {COURSE_STEPS.map((step) => (
        <SingleStep
          key={step.key}
          status={step.getStatus(course)}
          label={step.label}
          stepIcon={step.stepIcon}
          isFocused={activeStep === step.key}
          onClick={() => handleStepClick(step.key)}
        />
      ))}
    </div>
  );
};
